import { render, staticRenderFns } from "./TheDrawer.vue?vue&type=template&id=23a40e6e&scoped=true&lang=pug&"
import script from "./TheDrawer.vue?vue&type=script&lang=js&"
export * from "./TheDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a40e6e",
  null
  
)

export default component.exports